import React from "react";
import { Helmet } from "react-helmet";
import Dashboard from "../../../layouts/Dashboard";
import { useDashboard } from "../DashboardProvider/DashboardProvider";
import MyMembers from "../ActivitySummary/MyMembers";
import MySchedule from "../MySchedule/MySchedule";
import GetStartedProgressBar from "./GetStartedProgressBar";
import QuickActions from "./QuickActions";
import { AdaptiveSheet } from "@pushpress/pushpress-ui";
import MyGym from "../MyGym/MyGym";
import useTailwindBreakpoint from "../../../hooks/useTailwindBreakpoint";
import { useAppSetting } from "../../../apis/appStore.hooks";
import { usePrefetchTodaysClasses } from "../DashboardSheetContent/useTodaysClasses";
const DashboardSheetTitle: React.FC<{ title: string }> = ({ title }) => {
  return <div className="tw-py-2 tw-px-4">{title}</div>;
};

function DashboardLanding() {
  const { isSheetOpen, closeSheet, sheetContent } = useDashboard();
  const { isMdScreen } = useTailwindBreakpoint();
  usePrefetchTodaysClasses();

  let { value: cancelRequestsEnabled } = useAppSetting(
    "pushpress-membersportal",
    "allow-membership-cancellations",
  );
  cancelRequestsEnabled =
    cancelRequestsEnabled === true || cancelRequestsEnabled === null;

  const colHeight = cancelRequestsEnabled ? "763px" : "680px";

  return (
    <>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <Dashboard scrollableContent disableContentPadding>
        <div className="tw-pt-4 tw-pb-20">
          <div className="tw-px-4 tw-max-w-4xl tw-mx-auto tw-pb-6 tw-w-full">
            <div className="tw-py-4">
              <div>
                <GetStartedProgressBar />
              </div>
              <div className="tw-space-y-8">
                <div>
                  <QuickActions />
                  <MyGym />
                </div>

                {isMdScreen && (
                  <div className="tw-grid tw-grid-cols-2 tw-gap-8 tw-h-[600px]">
                    <MyMembers cancelRequestsEnabled={cancelRequestsEnabled} />
                    <MySchedule />
                  </div>
                )}

                {!isMdScreen && (
                  <div className="tw-flex tw-flex-col tw-space-y-8">
                    <div className={`tw-h-[${colHeight}]`}>
                      <MyMembers
                        cancelRequestsEnabled={cancelRequestsEnabled}
                      />
                    </div>
                    <div className={`tw-h-[${colHeight}]`}>
                      <MySchedule />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <AdaptiveSheet
              titleComponent={
                <DashboardSheetTitle title={sheetContent?.title ?? ""} />
              }
              isOpen={isSheetOpen}
              onClose={closeSheet}
              description=""
              contentClassName="!tw-p-0"
            >
              <div>{sheetContent?.children}</div>
            </AdaptiveSheet>
          </div>
        </div>
      </Dashboard>
    </>
  );
}

export default DashboardLanding;
